// source: https://docs.union.theknot.com/docs/pattern-library/getting-started/global-state#initialize-membership-state

import { getMember } from '@xo-union/store-membership-redux';
import store from '../store';

const loadMember = () => {
  store.dispatch(getMember());
};

export default loadMember;
